<nz-divider
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #text>
        <div class="sider-divider-text">UPLIFT REFERENCE SEGMENT</div>
    </ng-template>
</nz-divider>
<nz-select
    *ngIf="upliftReferenceSegmentSettingId"
    style="width: 100%"
    [nzAllowClear]="true"
    [nzDropdownMatchSelectWidth]="false"
    [(ngModel)]="selectedUpliftReferenceSegmentViewModel"
    (ngModelChange)="onSelectedUpliftSegmentModelChange($event)"
    [nzOptionOverflowSize]="19"
    [nzOptionHeightPx]="25"
    [nzPlaceHolder]="'Select uplift reference segment'"
    nzSize="small"
    [nzDisabled]="disableSegmentSelection"
    [nz-tooltip]="disableSegmentSelection ? 'Toggle split to unlock' : null"
>
    <nz-option
        *ngFor="let item of availableSegments"
        [nzLabel]="item"
        [nzValue]="item"
    ></nz-option>
</nz-select>
